"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importDefault(require("react"));
var ModuleHeader_1 = tslib_1.__importDefault(require("../moduleHeader/ModuleHeader"));
var ProductBox_1 = tslib_1.__importDefault(require("../_common/ProductBox"));
var WidgetContainer_1 = tslib_1.__importDefault(require("../_common/WidgetContainer"));
var ProductHighlight = function (_a) {
    var isoLocale = _a.isoLocale, moduleHeader = _a.moduleHeader, product = _a.product, textColor = _a.textColor;
    return (react_1.default.createElement(WidgetContainer_1.default, null,
        moduleHeader && react_1.default.createElement(ModuleHeader_1.default, { moduleData: moduleHeader, textColor: textColor }),
        react_1.default.createElement(ProductBox_1.default, { product: product, isoLocale: isoLocale })));
};
exports.default = react_1.default.memo(ProductHighlight);
//# sourceMappingURL=ProductHighlight.js.map